<template>
  <CModal :show.sync="show" :title="$gettext('Upload files')" centered>
    <div class="mb-2"><translate>Total file to upload</translate>: {{ total }}</div>
    <ul class="list-unstyled mb-2">
      <li v-for="(count, tag) in tags" :key="tag" class="mb-2">
        <CBadge class="badge-outline mr-2" shape="pill" color="primary">
          {{ tag }}
        </CBadge>
        {{ count }} files
      </li>
    </ul>
    <ul class="list-unstyled mb-2">
      <li v-for="(count, picaCode) in picaCodes" :key="picaCode" class="mb-2">
        <CBadge class="badge-outline mr-2" shape="pill" color="success">
          PICA CODE: {{ picaCode }}
        </CBadge>
        {{ count }} <translate>files</translate>
      </li>
    </ul>
    <ul class="list-unstyled mb-2">
      <li v-for="gallery in galleries" :key="gallery.id" class="mb-2">
        <CBadge class="badge-outline mr-2" shape="pill" color="success">
          GALLERY: {{ gallery.name }}
        </CBadge>
        {{ gallery.count }} <translate>files</translate>
      </li>
    </ul>
    <template #footer>
      <CButton size="sm" @click="show = false" color="secondary" v-translate>Close</CButton>
      <CButton size="sm" @click="onConfirm" color="primary" translate-context="uploader.to_upload" v-translate>
        Upload
      </CButton>
    </template>
  </CModal>
</template>
<script>

export default {
  name: "Summary",
  data() {
    return {
      show: false,
      files: []
    }
  },
  computed: {
    total() {
      return this.files.length
    },
    picaCodes() {
      let picaCodes = {}
      this.files.forEach(file => {
        if (file.picaCode) {
          if (!picaCodes[file.picaCode]) picaCodes[file.picaCode] = 0
          picaCodes[file.picaCode]++
        }
      })
      return picaCodes
    },
    galleries() {
      let galleries = {}
      this.files.forEach(file => {
        if (file.gallery) {
          const id = file.gallery.id
          if (!galleries[id]) {
            galleries[id] = {
              ...file.gallery,
              count: 0
            }
          }
          galleries[id]['count']++
        }
      })
      return galleries
    },
    tags() {
      let tags = {}
      this.files.forEach(file => {
        file.tags.forEach(tag => {
          if (!tags[tag]) tags[tag] = 0
          tags[tag]++
        })
      })
      return tags
    }
  },
  emits: ['confirm'],
  methods: {
    open(files) {
      this.files = files
      this.show = true
    },
    onConfirm() {
      this.$emit('confirm', this.files)
      this.show = false
    }
  }
}
</script>

<style scoped>

</style>